import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=f23f8c46"
import script from "./calendar.js?vue&type=script&lang=js&external"
export * from "./calendar.js?vue&type=script&lang=js&external"
import style0 from "./calendar.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports